import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import './ListQuote.scss';
class ListQuote extends Component {
  renderListDB = () => {
    return this.props.list.reverse().map((item, index) => {
      return (
        <tr key={index} className="listDbQuoteDiv">
          {/* <td>
            <div className="text-sm text-gray-500">{index + 1}</div>
          </td> */}
          <td>
            <div className="text-sm text-gray-500">
              <textarea className="listDbQuote" value={item.quote}/>
            </div>
          </td>
          {/* <td>
            <div className="text-sm text-gray-500">{item.type}</div>
          </td>
          <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
            <a href="#" className="text-indigo-600 hover:text-indigo-900">
              Edit
            </a>
          </td> */}
        </tr>
      );
    });
  };
  render() {
    return (
      <div className="flex flex-col flex-Child">
        <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <div className="text-red">Total quote: {this.props.list.length}</div>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {/* <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      STT
                    </th> */}
                    <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      QUOTE
                    </th>
                    {/* <th
                      scope="col"
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                    >
                      TYPE
                    </th>
                    <th scope="col" className="relative px-6 py-3">
                      <span className="sr-only">Edit</span>
                    </th> */}
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                  {this.renderListDB()}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const withStore = connect(
  (state) => ({
    list: state.quotes.listQuote,
  }),
  null
);
export default compose(withStore)(ListQuote);
